import { render, staticRenderFns } from "./searchBK.vue?vue&type=template&id=22b1dea6&"
import script from "./searchBK.vue?vue&type=script&lang=js&"
export * from "./searchBK.vue?vue&type=script&lang=js&"
import style0 from "./searchBK.vue?vue&type=style&index=0&id=22b1dea6&prod&scpoed=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports